<template>
    <div id="frame" style="background-color: white; position:relative;" class="table-resize-adjust" :class="['frame-margin']">
        
        <div v-if="readingDocument" class="document-btn-container">
            <dynButton :configs="{ID: 'buttons.docLeftArrow', visible: true}" :exec='backward'
                :icon="$root.icons.left" btnClasses="btn-primary" 
                :styleObj="{'margin': '1px 0px 2px 6px', 'padding': '3px 7px 5px 7px', 'position': 'relative', 'top': '4px', 'border-radius': '3px', 'height': '28px'}">
            </dynButton>
            <input style="margin: 0px 4px 0px 4px; padding: 0px 4px 3px 3px; position: relative; top: 4px; border-radius: 3px; width: 50px;"
               type="number"
               min="1"
               :max="reading.np"
               :value="readingPage" @change="submitPager">
            </input>
            <dynButton :configs="{ID: 'buttons.docRightArrow', visible: true}" :exec='forward'
                :icon="$root.icons.right" btnClasses="btn-primary" 
                :styleObj="{'margin': '1px 0px 2px 0px', 'padding': '3px 7px 5px 7px', 'position': 'relative', 'top': '4px', 'border-radius': '3px', 'height': '28px'}">
            </dynButton>
            <dynButton :configs="{ID: 'buttons.docClose', visible: true}" :exec='loadContent'
                :icon="$root.icons.close" btnClasses="btn-primary" 
                :styleObj="{'margin': '1px 0px 2px 4px', 'padding': '3px 7px 5px 7px', 'position': 'relative', 'top': '4px', 'border-radius': '3px', 'height': '28px'}">
            </dynButton>
            <dynButton :configs="{ID: 'buttons.docDownload', visible: true}" :exec='downloadContent'
                :icon="$root.icons.download" btnClasses="btn-primary" 
                :styleObj="{'margin': '1px 0px 2px 4px', 'padding': '3px 7px 5px 7px', 'position': 'relative', 'top': '4px', 'border-radius': '3px', 'height': '28px'}">
            </dynButton>
            <div class="sk-cube-grid" v-if="isLoading" style="height:20px; width:20px; z-index: 9999; margin-top: -21px; margin-left: 58px;">
                <!--v-if="isLoading" "display: block; height: 100%; text-align: center; position: absolute;z-index:9999;top: 0px;width: 100%;height: 100%;background: white;opacity: 0.8;"-->
                <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
            </div>
        </div>
        <div v-if="readingNoChildrenNode" class="document-btn-container">
            <dynButton :configs="{ID: 'buttons.docClose', visible: true}" :exec='loadContent'
                :icon="$root.icons.close" btnClasses="btn-primary" 
                :styleObj="{'margin': '1px 0px 2px 4px', 'padding': '3px 7px 5px 7px', 'position': 'relative', 'top': '5px','left': '4px', 'border-radius': '3px', 'height': '28px'}">
            </dynButton>
        </div>
        <div id="viewer_wrapper" style="display: block; height: 100%; text-align: center;"></div> 
    </div>
</template>
<script>
    
import { eventBus } from "../../eventbus";
import DynButton from "../dynamic/DynButton.vue";
import viewer_mixin from '../../mixins/viewer_mixin.js';

    export default {
        props: {
            activeData: Object,
            focus: String
        },
        components: {
            DynButton
        },
        mounted: function(){
            if(this.activeData && !this.$root.showOnlyImg){
                this.loadContent();
            }else{
                this.loadContentSpecial(this.$root.toShow)
            }
        },
        created: function(){
            var vm = this;
            this.$nextTick(function(){
                eventBus.$on("read_pdf", function(params){
                    vm.reading = params.d;
                    vm.loadDocument(1, params.from)
                })
                eventBus.$on("pdf_exists", function(callback){
                    if(vm.reading != null && vm.readingDocument){
                        console.log(vm.reading)
                        callback({reading: vm.reading, readingPage: vm.readingPage})
                    }
                })
                eventBus.$on("go_to_page", function(page){
                    if(vm.reading != null && vm.readingDocument){
                        vm.loadDocument(page)
                    }
                })
            });
            
        },  
        beforeDestroy: function(){
            this.reading = null;
            eventBus.$off("pdf_exists");
            eventBus.$off("read_pdf");
            eventBus.$off("go_to_page");
            eventBus.$emit("unloadDocument")
        },
        mixins: [viewer_mixin],
        data: function(){
            var vm = this;
            return {
                viewerInstance: null,
                /* options:  {
                    id: "viewer_wrapper",
                    cb: {
                        selected: function (selection) {
                            var routing_params = null;
                            var existing_query;
                            try {
                                existing_query = vm.$route.query.p;
                            } catch (err) {}

                            if(selection == vm.$route.params.focus){
                                //cliccato nell'hotspot già evidenziato
                                //rimuovo la selezione
                                routing_params = { id: vm.$route.params.id }
                            } else {
                                //focus hotspot
                                routing_params = { id: vm.$route.params.id, focus: selection }
                            }
                            
                            vm.$router.push({
                                name: "wrapper_focus",
                                params: routing_params,
                                query: existing_query ? { p: existing_query } : null
                            });

                            if (selection) {
                                // @pointedSelection attiva la navigazione (se abilitata), la navigateTo passa anche il padre per non mandare la procedura in errore
                                // @pointedSelection intercettata sia in Detail che Image
                                vm.$emit("pointedSelection")
                            } else {
                                console.log("CALLBACK SELECTION: UNSELECTED")
                            }

                        },
                        linked: function(link){
                            var routing_params = null;
                            var existing_query;
                            try {
                                existing_query = vm.$route.query.p;
                            } catch (err) {}

                            var target = null;
                            vm.activeData.children.some(function(o){
                                if(link == o[vm.$Behaviors.focusBy()]){
                                    target = o.sid;
                                    if(o.lin && o.gra.length>0){ //se il nodo ha lin true e c'è un disegno allegato
                                        vm.$root.showOnlyImg = true;
                                        vm.$root.toShow = o.gra
                                    }
                                    return true;
                                }
                                return false;
                            })
                            console.log(vm.$root.showOnlyImg)
                            if(vm.$root.showOnlyImg){
                                vm.loadContentSpecial(vm.$root.toShow)
                            }else{
                                console.log("target found -> " + target)
                                
                                if(target){
                                    var params = {
                                        source: existing_query,
                                        target: target,
                                        search: "id"
                                    }
                                    console.log("link has been triggered: ", params)

                                    vm.isLoading = true;
                                    vm.$root
                                        .microservice({
                                            role: "catalog",
                                            cmd: "GetLinkPath",
                                            params: params
                                        }).then( response => {
                                            
                                            vm.isLoading = false;
                                            var res = response.body;
                                            try {
                                                res = JSON.parse(response.body);
                                            } catch (err) {}
                                            console.log(res)
                                            if(res.error){
                                                eventBus.$emit('alert', {
                                                    message: 'Riferimento non trovato nei figli del modello', //res.error ? res.error : 'La richiesta non è andata a buon fine',
                                                    type: "error"
                                                })
                                            } else if(res.path){
                                                var path = res.path.split("?")
                                                var target = path.pop();
                                                path = path.join("?")
                                            
                                                vm.$root.navigateTo(target, null, null, path)
                                            }
                                        })
                                        .catch(err => {
                                            console.log(err);
                                            var msg = err && err.body && err.body.error ? err.body.error : ''
                                            eventBus.$emit('alert', {
                                                message: "Application caught an error <br> <h5>Details: " + "catalog.GetLinkPath - " + msg +'</h5>',
                                                type: "error",
                                                action: ''
                                            })
                                        });
                                } else {
                                    eventBus.$emit('alert', {
                                        message: 'Associazione a link non trovata nel nodo corrente', //res.error ? res.error : 'La richiesta non è andata a buon fine',
                                        type: "error"
                                    })
                                }
                            }
                        },
                        detail: function(selection){
                            eventBus.$emit('hotspot_tapped', selection)
                        }
                    },
                    prefs: {
                        selector: "pos",
                        color: "#3c8dbc",
                        resizeIcon: "<i class='"+vm.$root.icons.adapt+"' aria-hidden='true' style='margin: 2px; font-size: 1.5em;'></i>",
                        nocache: false
                    }
                }, */
                reading: null,
                readingDocument: false,
                readingNoChildrenNode: false,
                readingPage: null,
                isLoading: false
            }
        },
        watch: {
            //TODO: catch error in watcher ?
            activeData: function(){
                if(!this.$root.showOnlyImg){
                    this.loadContent();
                }
            },
            focus: function(){
                this.selectChild();
            }
        },
        methods: {
            /* loadContent: function(){
                this.reading = null;
                this.readingPage = null;
                if(this.readingDocument){
                    this.readingDocument = false;
                    eventBus.$emit("unloadDocument")
                }
                if(this.readingNoChildrenNode){
                    this.readingNoChildrenNode = false;
                    this.$root.showOnlyImg = false;
                    eventBus.$emit("changeView", 'Detail');
                    eventBus.$emit("defaultView", 'Detail');
                    this.$root.styleSupportSidebarIcons();
                }

                if(this.activeData && this.activeData.father){
                    if (this.viewerInstance == null) {
                        this.viewerInstance = window.Viewer.createViewer(this.options)
                    }
                    var showing = null;
                    try {
                        showing = this.activeData.father.gra[0].sfn
                        showing = escape(showing)
                    } catch(err){}
                    showing = showing != null ? showing : "missing";

                    var url = this.$root.getGraphic(showing, "display", false)
                  
                    this.viewerInstance.load({
                        url: url,
                        highlightTxt: this.focus,
                        childNodes: this.activeData.children
                    },()=>{})
                }
            },
            loadContentSpecial: function(gra){
                this.readingNoChildrenNode = true
                if(gra[0] && gra[0].sfn){
                    if (this.viewerInstance == null) {
                        this.viewerInstance = window.Viewer.createViewer(this.options)
                    }
                    var showing = null;
                    try {
                        showing = gra[0].sfn
                        showing = escape(showing)
                    } catch(err){}
                    showing = showing != null ? showing : "missing";
                    var url = this.$root.getGraphic(showing, "display", false)
                  
                    this.viewerInstance.load({
                        url: url,
                        highlightTxt: null,
                        childNodes: []
                    },()=>{})
                    
                    eventBus.$emit("changeView", 'ImgLayout');
                    eventBus.$emit("defaultView", 'ImgLayout');
                    this.$root.styleSupportSidebarIcons();
                }                
            }, */
            selectChild: function(){
                if(this.viewerInstance){
                    this.viewerInstance.selectItem(this.focus);
                }
            },
            /* loadDocument: function(page, from){
                this.readingDocument = true;
                if(this.reading && this.reading.filename){
                    if (this.viewerInstance == null) {
                        this.viewerInstance = window.Viewer.createViewer(this.options)
                    }
                    var showing = null;
                    try {
                        showing = this.getPage(this.reading.filename, page, this.reading.np)
                        this.readingPage = page;
                        eventBus.$emit("read_pdf_page", this.readingPage)
                    } catch(err){
                        console.log(err)
                    }
                    showing = showing != null ? showing : "missing";
                    console.log(showing)
                    var url = this.$root.msPath +"/"+ this.$Configs.licenseId +"/doc/pag/" + this.reading.filename + "/" + showing;
                    url += ".svgz"
                    var vm = this;
                    this.viewerInstance.load({
                        url: url,
                        childNodes: []
                    }, () => {
                        vm.isLoading = false;
                        eventBus.$emit('document_loaded') 
                        if(from == 'rec-list-doc')eventBus.$emit("openSidebarDocumenti")
                    })
                }
            }, */
            forward: function(){
                var vm = this;
                if(this.reading && this.readingPage < this.reading.np){
                    var next = this.readingPage + 1
                    this.isLoading = true;
                    /* this.$nextTick(()=>{
                        vm.loadDocument(next);
                    }) */
                    setTimeout(()=>{
                        vm.loadDocument(next);
                    },0)
                }
            },
            backward: function(){
                var vm = this;
                if(this.reading && this.readingPage > 1){
                    var next = this.readingPage - 1
                    this.isLoading = true;
                    /* this.$nextTick(()=>{
                        vm.loadDocument(next);
                    }) */
                    setTimeout(()=>{
                        vm.loadDocument(next);
                    },0)
                }
            },
            submitPager: function($event){
                var s = 1;
                try {
                    s = $event.target.valueAsNumber
                } catch(err){
                    console.log(err)
                }
                if(s < 1){
                    s = 1;
                }
                if(s > this.reading.np){
                    s = this.reading.np;
                }
                if(s != this.readingPage){
                    this.loadDocument(s);
                }
            },
            getFigure4: function(n){
                n = n.toString();
                var figures = n.length;
                var res = "";
                for(var i = 0; i < 4-figures; i++){
                    res += "0"
                }
                res += n;
                return res;
            },
            getPage: function(name, npage, ntot){
                return name + "_p" + this.getFigure4(npage) + "-" + this.getFigure4(ntot);
            },
            downloadContent: function(){
                window.open(this.$root.msPath + '/'+ this.$Configs.licenseId +'/doc/src/' + this.reading.filename + '.pdf');
            }
        }
    }

</script>
<style scoped>
    .document-btn-container {
        position: absolute;
        left: 42px;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/sub-views/ViewerContainer.vue?5cdc6a30